export const products = [
  {
    id: 1,
    name: 'Facial Cleanser',
    category: 'Skincare',
    targetMarket: ['Skin Clinics', 'Spas and Beauty Centers', 'Retail'],
    image: 'https://images.unsplash.com/photo-1631730359585-38a4935cbec4?q=80&w=2075',
    description: 'Gentle yet effective facial cleanser with natural ingredients.',
    features: [
      'pH balanced formula',
      'Suitable for all skin types',
      'Removes impurities without drying'
    ],
    price: 1200,
    minOrder: 50
  },
  {
    id: 2,
    name: 'Vitamin C Serum',
    category: 'Skincare',
    targetMarket: ['Skin Clinics', 'Pharmacies', 'Retail'],
    image: 'https://images.unsplash.com/photo-1608248597279-f99d160bfcbc?q=80&w=2070',
    description: 'Brightening serum with stable Vitamin C for radiant skin.',
    features: [
      'Contains 20% Vitamin C',
      'Antioxidant protection',
      'Improves skin texture'
    ],
    price: 1500,
    minOrder: 30
  },
  {
    id: 3,
    name: 'Hydrating Toner',
    category: 'Skincare',
    targetMarket: ['Spas and Beauty Centers', 'Retail', 'Resellers'],
    image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?q=80&w=2071',
    description: 'Alcohol-free toner that hydrates and balances the skin.',
    features: [
      'Alcohol-free formula',
      'Contains hyaluronic acid',
      'Balances skin pH'
    ],
    price: 980,
    minOrder: 50
  },
  {
    id: 4,
    name: 'Collagen Cream',
    category: 'Skincare',
    targetMarket: ['Skin Clinics', 'Spas and Beauty Centers', 'Influencers/KOLs'],
    image: 'https://images.unsplash.com/photo-1612817288484-6f916006741a?q=80&w=2070',
    description: 'Rich moisturizing cream with collagen peptides for firm skin.',
    features: [
      'Marine collagen peptides',
      'Deep hydration',
      'Anti-aging properties'
    ],
    price: 1800,
    minOrder: 30
  },
  {
    id: 5,
    name: 'Sunscreen SPF50',
    category: 'Sun Protection',
    targetMarket: ['Pharmacies', 'Retail', 'Resellers'],
    image: 'https://images.unsplash.com/photo-1576426863848-c21f53c60b19?q=80&w=2070',
    description: 'Broad-spectrum sunscreen with high UV protection.',
    features: [
      'SPF50+ PA++++',
      'Lightweight formula',
      'Water-resistant'
    ],
    price: 1100,
    minOrder: 100
  },
  {
    id: 6,
    name: 'Peptide Eye Cream',
    category: 'Skincare',
    targetMarket: ['Skin Clinics', 'Spas and Beauty Centers', 'Influencers/KOLs'],
    image: 'https://images.unsplash.com/photo-1615397349754-cfa2066a298e?q=80&w=1974',
    description: 'Advanced eye cream targeting fine lines and dark circles.',
    features: [
      'Multi-peptide complex',
      'Reduces dark circles',
      'Improves elasticity'
    ],
    price: 2200,
    minOrder: 25
  },
  {
    id: 7,
    name: 'AHA/BHA Exfoliant',
    category: 'Treatment',
    targetMarket: ['Skin Clinics', 'Pharmacies', 'Retail'],
    image: 'https://images.unsplash.com/photo-1592136957897-b2b6ca21e10d?q=80&w=1974',
    description: 'Gentle exfoliating solution for smoother, clearer skin.',
    features: [
      'Combination of AHA & BHA',
      'Unclogs pores',
      'Improves skin texture'
    ],
    price: 1350,
    minOrder: 40
  },
  {
    id: 8,
    name: 'Niacinamide Serum',
    category: 'Treatment',
    targetMarket: ['Skin Clinics', 'Pharmacies', 'Resellers'],
    image: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?q=80&w=2070',
    description: 'Pore-minimizing and brightening serum with 10% Niacinamide.',
    features: [
      '10% Niacinamide',
      'Reduces pore appearance',
      'Controls oil production'
    ],
    price: 1400,
    minOrder: 35
  },
  {
    id: 9,
    name: 'Centella Moisturizer',
    category: 'Skincare',
    targetMarket: ['Spas and Beauty Centers', 'Retail', 'Resellers'],
    image: 'https://images.unsplash.com/photo-1611930022073-b7a4ba5fcccd?q=80&w=2070',
    description: 'Calming moisturizer with Centella Asiatica for sensitive skin.',
    features: [
      'Centella Asiatica extract',
      'Soothes irritation',
      'Strengthens skin barrier'
    ],
    price: 1600,
    minOrder: 45
  },
  {
    id: 10,
    name: 'Retinol Night Cream',
    category: 'Treatment',
    targetMarket: ['Skin Clinics', 'Pharmacies', 'Influencers/KOLs'],
    image: 'https://images.unsplash.com/photo-1617897903246-719242758050?q=80&w=2070',
    description: 'Anti-aging night cream with encapsulated retinol.',
    features: [
      'Encapsulated retinol',
      'Reduces fine lines',
      'Improves skin renewal'
    ],
    price: 2500,
    minOrder: 20
  }
]; 